import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
	selector: 'cv-save-button',
	templateUrl: './save-button.component.html',
	styleUrls: ['./save-button.component.scss'],
})
export class SaveButtonComponent implements OnInit {
	@Input() saving: boolean;
	@Input() isDirty: boolean;
	@Output() saveForm: EventEmitter<any> = new EventEmitter();

	constructor() { }

	ngOnInit(): void { }

	onSave(): void {
		this.saveForm.emit(null);
	}
}
